export class CreatedProfile{

  constructor(
    public uid: string,
    public creater: string,
    public name: string,
    public short_name: string,
    public registration_date: string,
    public status: string,
    public num_offers: number,
    public img_url?: string,
    public email?: string,
    public phone?: any,
    public phone2?: any
  ){}
}
